import { render, staticRenderFns } from "./AnswerBoolean.vue?vue&type=template&id=033dd244&"
import script from "./AnswerBoolean.vue?vue&type=script&lang=js&"
export * from "./AnswerBoolean.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports